import React from "react";
import { ShieldCheck } from "lucide-react";
import { getTranslationsForLanguage } from "@/i18n";

export default function SafetyBriefingCard({ lang = "en" }) {
  const t = getTranslationsForLanguage(lang, "dailyBriefing").safety;
  const day = Math.floor(Date.now() / 86400000);
  const tip = t.tips[day % t.tips.length];
  return (
    <article className="rounded-[2rem] border border-border bg-card p-6 shadow-xl shadow-ocean/5">
      <div className="flex items-start justify-between gap-4">
        <div><p className="text-sm font-black uppercase tracking-[0.18em] text-primary">{t.eyebrow}</p><h3 className="mt-2 text-2xl font-black">{tip.title}</h3></div>
        <ShieldCheck className="h-8 w-8 text-primary" />
      </div>
      <p className="mt-4 leading-7 text-muted-foreground">{tip.text}</p>
      <div className="mt-5 rounded-2xl bg-primary/10 p-4 text-sm font-bold text-primary">{t.footer}</div>
    </article>
  );
}